// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9e7c327e","455":"d70566ac","977":"8bf0cd2c"}[chunkId] + ".chunk.js";
};